import React from "react";
import { PlusOutlined } from "@ant-design/icons";
import { ButtonCommon } from "components/common";

interface AddNewRowButtonProps {
  onAdd: () => void;
  text?: string;
}

const AddNewRowButton: React.FC<AddNewRowButtonProps> = ({
  onAdd,
  text = "Thêm mới",
}) => (
  <div className="flex items-center mt-[12px]">
    <ButtonCommon
      icon={<PlusOutlined />}
      onClick={onAdd}
      className="text-[var(--primaryColor500)]"
      color="none"
    >
      {text}
    </ButtonCommon>
  </div>
);

export default AddNewRowButton;
